import * as React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TextField,
  Grid,
  InputAdornment,
  Backdrop,
  alpha,
  styled,
  MenuProps,
  Menu,
  MenuItem,
  tooltipClasses,
  TooltipProps,
  Tooltip,
  Button,
  Collapse,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { useContext, useEffect, useRef, useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { PAGE_SIZE } from "../../Services/common/const";
import { PreferencesContext } from "../../PreferencesContext";
import MissingConsumer from "../../Components/MissingConsumer";
import DownloadIcon from "@mui/icons-material/Download";
import "../../Theme/main.scss";
import {
  ExportFilesFunction,
  getSingleSelected,
  numberFormat,
  numberFormatWithCrDr,
} from "../../shared/CommonFuctions";
import { GetStockLedgerReport } from "../../Services/ReportService";
import { useTheme } from "@mui/material/styles";
import { EncryptDecryptService } from "../../Services/common/EncryptionService";
import { KeyboardArrowDownSharp } from "@mui/icons-material";
import SplashComponent from "../../Navigation/splash";
import { GetLedgerMonthlySummaryList } from "../../Services/LedgerSummaryService";
import { GetLedgerMonthlySummaryReport } from "../../Services/ReportService";
import { LoadingButton } from "@mui/lab";
import ShortcutButton from "../../Components/ShortcutButton";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { CustomSelect } from "../../Components/CustomSelect";
import { SUMMARY_BY_DATETIME } from "../../StaticData/DataHelper";
import Select from "react-select";
import { format, isValid, parse } from "date-fns";
import { AlertType } from "../../shared/Modal/AlertType";
import { GetStockSummaryLedgerList } from "../../Services/StockService";
import { GetProductList } from "../../Services/CategoryProductService";

interface Data {
  creditId: number;
  creditType: string;
  creditDate: string;
  none: string;
}

type Order = "asc" | "desc" | "";

interface EnhancedTableProps {
  order: Order;
  orderBy: String;
  rowCount: number;
}

function EnhancedTableHead(props: EnhancedTableProps) {
  return (
    <TableHead className="table-header-color">
      <TableRow>
        <TableCell
          sx={{
            display: {
              xs: "table-cell",
              sm: "table-cell",
              md: "table-cell",
              lg: "table-cell",
            },
            fontWeight: "bold",
          }}
          align="left">
          {""}
        </TableCell>
        <TableCell
          sx={{
            display: {
              xs: "table-cell",
              sm: "table-cell",
              md: "table-cell",
              lg: "table-cell",
            },
            fontWeight: "bold",
          }}
          align="left">
          {"Ledger"}
        </TableCell>
        <TableCell
          sx={{
            display: {
              xs: "table-cell",
              sm: "table-cell",
              md: "table-cell",
              lg: "table-cell",
            },
            fontWeight: "bold",
          }}
          align="right">
          {"Inward Qty"}
        </TableCell>
        <TableCell
          sx={{
            display: {
              xs: "table-cell",
              sm: "table-cell",
              md: "table-cell",
              lg: "table-cell",
            },
            fontWeight: "bold",
          }}
          align="right">
          {"Outward Qty"}
        </TableCell>
        <TableCell
          sx={{
            display: {
              xs: "table-cell",
              sm: "table-cell",
              md: "table-cell",
              lg: "table-cell",
            },
            fontWeight: "bold",
          }}
          align="right">
          {"Closing Balance"}
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

const ledgerSummary: any = {
  ledgermonthSummaryColl: [],
};
const parameters: any = {
  consumerId: 1,
  creditType: 0,
  startDate: "",
  endDate: "",
  pageIndex: 1,
  pageSize: PAGE_SIZE,
  sortColumn: "",
  sortDirection: "",
  searchValue: "",
};

export default function GetStockSummaryLedger() {
  const edService = new EncryptDecryptService();
  const matches = useMediaQuery("(max-width:899px)");
  const matches2 = useMediaQuery("(max-width:599px)");
  
  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let navigate = useNavigate();
  let location = useLocation();
  let urlParams = useQuery();
  
  // Read encrypted params from URL
  let enledgerAccountId: any = urlParams.get("q");
  let enLedgerAccountDetailId = urlParams.get("d");
  
  // Decrypt to get actual IDs
  let decLedgerAccountDetailId: any = edService.decrypt(enLedgerAccountDetailId);
  let decledgerAccountId: any = edService.decrypt(enledgerAccountId);
  
  // Convert to int
  const decledgerAccountIds = decledgerAccountId ? parseInt(decledgerAccountId) : 0;
  const decLedgerDetailId = decLedgerAccountDetailId ? parseInt(decLedgerAccountDetailId) : 0;

  console.log('Decrypted productId:', decledgerAccountIds);
  
  const [totalAmount, setTotalAmount] = useState(0);
  const [param, setParam] = useState(parameters);
  const [anchorEl, setAnchorEl3] = useState<HTMLButtonElement | null>(null);
  const [anchorEl0, setAnchorEl0] = useState<HTMLButtonElement | null>(null);
  const [creditId, setCreditId] = useState(null);
  const open = Boolean(anchorEl);
  const [order, setOrder] = useState<Order>("");
  const [orderBy, setOrderBy] = useState<keyof Data>("none");
  const [selected, setSelected] = useState<readonly number[]>(
    ledgerSummary.ledgerSummaryColl
  );
  const [dense, setDense] = useState(false);
  const [value, setValue] = useState("");
  const [openDilog, setopenDilog] = useState(false);
  const [page_Index, setPage_Index] = useState(1);
  const { userContext, updateUserContext } = useContext(PreferencesContext);
  const [isLoading, setLoading] = useState(false);
  const [openInvoice, setOpeninvoice] = useState(false);
  const [openInvoiceDownload, setopenInvoiceDownload] = useState(false);
  const [pageindexUpdate, setPageindexUpdate] = useState(0);
  const theme = useTheme();
  const [selectedDateRange, setDateRange] = useState([
    {
      startDate: new Date(userContext.financialYearStartDate),
      endDate: new Date(userContext.financialYearEndDate),
      key: "selection",
    },
  ]);
  const [anchorEl2, setAnchorEl2] = useState<null | HTMLElement>(null);
  const [Curr_page, setCurrPage] = useState(1);
  const openExportType = Boolean(anchorEl2);
  const [resultTotalData, setResultTotalData] = useState<any>({
    inwardTotal: 0,
    outwardTotal: 0,
    closingBalanceTotal: 0,
    accountNature: "DR",
    accountName: "",
  });
  const [resultData, setResultData] = useState<any[]>([]);
  const [expandRow, setExpandRow] = React.useState<any[]>([]);
  const [arrow, setArrow] = useState(false);
  const [summaryType, setSummaryType] = useState("Monthly");
  const [selectedSummaryOption, setSelectedSummaryOption] = useState<any>(SUMMARY_BY_DATETIME[0]);
  
  const [productName, setProductName] = useState<string>("");
  const [sourceProductCollection, setSourceProductCollection] = React.useState<any[]>([]);

  // ✅ Helper: Get months between two dates
  const getMonthsBetweenDates = (startDate: Date, endDate: Date, isDetail: boolean = false) => {
  const months = [];
  const currentDate = new Date(startDate);
  currentDate.setDate(1);
  
  while (currentDate <= endDate) {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const monthName = currentDate.toLocaleString('default', { month: 'long' }).toUpperCase();
    
    // For detail view, show month with year
    let displayLabel = monthName;
    if (isDetail) {
      displayLabel = `${monthName} ${year}`;
    }
    
    months.push({
      key: `${year}-${String(month + 1).padStart(2, '0')}`,
      label: displayLabel,
      particulars: displayLabel,
      startDate: new Date(year, month, 1),
      endDate: new Date(year, month + 1, 0),
      isZeroPeriod: false,
      isDetail: isDetail
    });
    currentDate.setMonth(currentDate.getMonth() + 1);
  }
  return months;
};
  // ✅ Helper: Get quarters between two dates (FINANCIAL YEAR - April = Q1)
  const getQuartersBetweenDates = (startDate: Date, endDate: Date) => {
    const quarters = [];
    const currentDate = new Date(startDate);
    currentDate.setDate(1);
    
    // ✅ Ensure we start from the beginning of a quarter
    const month = currentDate.getMonth() + 1;
    if (month >= 4 && month <= 6) {
      currentDate.setMonth(3); // April
    } else if (month >= 7 && month <= 9) {
      currentDate.setMonth(6); // July
    } else if (month >= 10 && month <= 12) {
      currentDate.setMonth(9); // October
    } else if (month >= 1 && month <= 3) {
      currentDate.setMonth(0); // January
    }
    currentDate.setDate(1);
    
    while (currentDate <= endDate) {
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth() + 1;
      
      // ✅ Calculate financial year quarter (April = Q1)
      let quarter;
      let quarterYear;
      
      // ✅ Get the financial year start year
      let financialYearStart = year;
      if (month < 4) {
        financialYearStart = year - 1; // Jan-Mar belong to previous financial year
      }
      
      // ✅ Calculate which quarter (1-4)
      if (month >= 4 && month <= 6) {
        quarter = 1;
      } else if (month >= 7 && month <= 9) {
        quarter = 2;
      } else if (month >= 10 && month <= 12) {
        quarter = 3;
      } else if (month >= 1 && month <= 3) {
        quarter = 4;
      }
      
      quarterYear = financialYearStart;
      
      // ✅ Calculate quarter start and end dates
      let startMonth;
      let endMonth;
      
      if (quarter === 1) { startMonth = 3; endMonth = 5; } // Apr-Jun
      else if (quarter === 2) { startMonth = 6; endMonth = 8; } // Jul-Sep
      else if (quarter === 3) { startMonth = 9; endMonth = 11; } // Oct-Dec
      else { startMonth = 0; endMonth = 2; } // Jan-Mar (Q4)
      
      const start = new Date(quarterYear, startMonth, 1);
      const end = new Date(quarterYear, endMonth + 1, 0);
      
      const quarterLabel = `Q${quarter} ${quarterYear}`;
      
      quarters.push({
        key: `${quarterYear}-Q${quarter}`,
        label: quarterLabel,
        particulars: quarterLabel,
        startDate: start,
        endDate: end,
        isZeroPeriod: false
      });
      
      // ✅ Move to next quarter (3 months)
      currentDate.setMonth(currentDate.getMonth() + 3);
    }
    return quarters;
  };

  // ✅ Helper: Get half-years between two dates (Financial Year - April to March)
  const getHalfYearsBetweenDates = (startDate: Date, endDate: Date) => {
    const halfYears = [];
    
    // ✅ Start from April of the financial year
    let currentDate = new Date(startDate);
    currentDate.setDate(1);
    
    // ✅ If start date is not April, move to April of the same financial year
    const startMonth = currentDate.getMonth() + 1;
    if (startMonth < 4) {
      // If before April (Jan-Mar), go back to previous year's April
      currentDate.setFullYear(currentDate.getFullYear() - 1);
      currentDate.setMonth(3); // April
    } else if (startMonth >= 4 && startMonth <= 9) {
      // If Apr-Sep, start from April of current year
      currentDate.setMonth(3); // April
    } else {
      // If Oct-Dec, start from October of current year
      currentDate.setMonth(9); // October
    }
    currentDate.setDate(1);
    
    while (currentDate <= endDate) {
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth() + 1;
      
      // ✅ Calculate financial year half (April = H1)
      let half;
      let halfYear;
      
      // ✅ Get the financial year start year
      let financialYearStart = year;
      if (month < 4) {
        financialYearStart = year - 1;
      }
      
      // ✅ Calculate which half (1 or 2)
      if (month >= 4 && month <= 9) {
        half = 1;
      } else {
        half = 2;
      }
      
      halfYear = financialYearStart;
      
      // ✅ Calculate half-year start and end dates
      let startMonth2;
      let endMonth;
      
      if (half === 1) {
        // H1: April to September
        startMonth2 = 3;  // April
        endMonth = 8;    // September
      } else {
        // H2: October to March
        startMonth2 = 9;  // October
        endMonth = 11;   // December
      }
      
      const start = new Date(halfYear, startMonth2, 1);
      let end;
      if (half === 1) {
        end = new Date(halfYear, endMonth + 1, 0); // September 30
      } else {
        end = new Date(halfYear + 1, 2, 31); // March 31 of next year
      }
      
      const halfLabel = `H${half} ${halfYear}`;
      
      halfYears.push({
        key: `${halfYear}-H${half}`,
        label: halfLabel,
        particulars: halfLabel,
        startDate: start,
        endDate: end,
        isZeroPeriod: false
      });
      
      // ✅ Move to next half-year (6 months)
      currentDate.setMonth(currentDate.getMonth() + 6);
    }
    
    return halfYears;
  };

  // ✅ Helper: Get periods based on summary type
  const getPeriods = (type: string, startDate: Date, endDate: Date) => {
    if (type === 'Quarterly') {
      return getQuartersBetweenDates(startDate, endDate);
    } else if (type === 'HalfYearly') {
      return getHalfYearsBetweenDates(startDate, endDate);
    } else if (type== 'Detail'){
      return getMonthsBetweenDates(startDate, endDate, true);
    } 
    else {
      return getMonthsBetweenDates(startDate, endDate);
    }
  };

  const handleClickExportType = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleCloseExportType = () => {
    setAnchorEl2(null);
  };

const handleListBySummaryType = (e: any) => {
  if (e) {
    const selectedValue = e.value;
    console.log('Summary type changed to:', selectedValue);
    
    // If Detail is selected, navigate to Ledger Voucher
    if (selectedValue === 'Detail') {
      const encryptedProductId = edService.encrypt(decledgerAccountIds);
      const encryptedDetailId = edService.encrypt(0);
      
      navigate(`/stock-ledger-report?q=${encodeURIComponent(encryptedProductId)}&d=${encodeURIComponent(encryptedDetailId)}`, {
        state: {
          productId: decledgerAccountIds,
          startDate: format(selectedDateRange[0].startDate, "yyyy-MM-dd"),
          endDate: format(selectedDateRange[0].endDate, "yyyy-MM-dd"),
          productName: productName || 'Selected Product',
          fromSummary: true
        }
      });
      return;
    }
    
    // For Monthly, Quarterly, HalfYearly
    setSummaryType(selectedValue);
    setSelectedSummaryOption(e);
    GetStockSummaryLedger(selectedValue);
  }
};

  async function getProducts() {
    try {
      let params = new URLSearchParams();
      params.append("consumerId", userContext.consumerId.toString());
      params.append("firmId", userContext.firmId.toString());
      params.append("branchId", userContext.branchId.toString());
      params.append("pageIndex", "1");
      params.append("pageSize", "1000");
      params.append("sortColumn", "name");
      params.append("sortDirection", "ASC");
      params.append("searchValue", "");
      params.append("mode", "");
      params.append("financialYear", userContext.financialYear?.toString());
      
      const result: any = await GetProductList(params);
      if (result?.data?.data?.productCollection) {
        const formattedData = result.data.data.productCollection.map((item: any) => ({
          ...item,
          label: item.name,
          value: item.productId.toString(),
        }));
        setSourceProductCollection(formattedData);
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (decledgerAccountIds > 0 && sourceProductCollection.length > 0) {
      const product = sourceProductCollection.find(
        (p) => Number(p.productId) === Number(decledgerAccountIds)
      );
      if (product) {
        setProductName(product.name);
        console.log('Product Name from list:', product.name);
      }
    }
  }, [decledgerAccountIds, sourceProductCollection]);

  useEffect(() => {
    getProducts();
  }, []);

  // ✅ Restore summary type from navigation state when coming back
  useEffect(() => {
    const state = location.state as any;
    const summaryTypeFromState = state?.summaryType || '';
    
    if (summaryTypeFromState) {
      console.log('🔴 Restoring summary type from state:', summaryTypeFromState);
      setSummaryType(summaryTypeFromState);
      const option = SUMMARY_BY_DATETIME.find(
        (opt: any) => opt.value === summaryTypeFromState
      );
      if (option) {
        setSelectedSummaryOption(option);
      }
    }
  }, [location.state]);

  async function GetStockSummaryLedger(selectedType?: string) {
    setLoading(true);

    try {
      const finalProductId = decledgerAccountIds || 0;
      
      console.log('ProductId:', finalProductId);
      
      if (isNaN(finalProductId) || finalProductId === 0) {
        console.error('Invalid productId:', finalProductId);
        setResultData([]);
        setResultTotalData({
          inwardTotal: 0,
          outwardTotal: 0,
          closingBalanceTotal: 0,
          accountNature: "DR",
          accountName: "",
        });
        setLoading(false);
        return;
      }

      const typeToUse = selectedType || summaryType || "Monthly";

      let params = new URLSearchParams();
      params.append("consumerId", userContext.consumerId.toString());
      params.append("firmId", userContext.firmId.toString());
      params.append("branchId", userContext.branchId.toString());
      params.append("productId", finalProductId.toString());
      params.append("startDate", format(selectedDateRange[0].startDate, "yyyy-MM-dd"));
      params.append("endDate", format(selectedDateRange[0].endDate, "yyyy-MM-dd"));
      params.append("summaryType", typeToUse);

      console.log("API PARAMS:", params.toString());

      let result: any = await GetStockSummaryLedgerList(params);

      console.log("API RESULT:", result);

      let stockData = [];

      if (result?.data?.stockSummaryList && Array.isArray(result.data.stockSummaryList)) {
        stockData = result.data.stockSummaryList;
      }
      else if (result?.data?.StockSummaryList && Array.isArray(result.data.StockSummaryList)) {
        stockData = result.data.StockSummaryList;
      }
      else if (result?.data?.data?.stockSummaryList && Array.isArray(result.data.data.stockSummaryList)) {
        stockData = result.data.data.stockSummaryList;
      }
      else if (result?.data?.data?.StockSummaryList && Array.isArray(result.data.data.StockSummaryList)) {
        stockData = result.data.data.StockSummaryList;
      }
      else if (result?.data && Array.isArray(result.data)) {
        stockData = result.data;
      }
      else if (result?.data?.data && Array.isArray(result.data.data)) {
        stockData = result.data.data;
      }
      else if (Array.isArray(result)) {
        stockData = result;
      }

      console.log("📊 stockData length:", stockData?.length);

      // ✅ Log the actual data from API to see what labels are coming
      console.log("🔴 API Data samples:", stockData.map((item: any) => ({
        particulars: item.particulars || item.Particulars || item.month || item.Month,
        inwardQty: item.inwardQty || item.inward_qty || item.InwardQty,
        outwardQty: item.outwardQty || item.outward_qty || item.OutwardQty,
        closingBalance: item.closingQty || item.closing_qty || item.ClosingQty,
        startDate: item.startDate || item.start_date || item.StartDate,
        endDate: item.endDate || item.end_date || item.EndDate
      })));

      // ✅ Create a map for period data
      const periodDataMap = new Map();
      let openingStockData = null;
      
      // ✅ Process API data with better mapping
      stockData.forEach((item: any) => {
        const particulars = item.particulars || item.Particulars || item.month || item.Month || '';
        console.log("🔴 Processing item:", { particulars, item });
        
        if (particulars.toUpperCase().includes('OPENING')) {
          const closingBalance = Math.abs(Number(item.closingQty || item.closing_qty || item.ClosingQty || 0));
          openingStockData = {
            particulars: 'OPENING STOCK',
            inwardQty: closingBalance, // ✅ Use closing balance as inward qty
            outwardQty: 0,
            closingBalance: closingBalance,
            startDate: item.startDate || item.start_date || item.StartDate,
            endDate: item.endDate || item.end_date || item.EndDate,
            ledgerAccountId: item.productId || item.product_id || item.ProductId || finalProductId || 0,
            rowId: item.rowId || item.row_id || item.RowId || 0,
            isZeroPeriod: false
          };
          console.log("🔴 Opening Stock Data:", openingStockData);
          return;
        }
        
        // ✅ Try to extract quarter or half-year info
        let periodKey = particulars;
        
        // ✅ If it's a quarter (contains Q), map Calendar Year to Financial Year
        if (particulars.includes('Q')) {
          const match = particulars.match(/(Q[1-4])\s*(\d{4})/);
          if (match) {
            let quarterNum = parseInt(match[1].replace('Q', ''));
            const year = parseInt(match[2]);
            
            let financialQuarter;
            let financialYear;
            
            if (quarterNum === 1) {
              // Jan-Mar -> Q4 of previous financial year
              financialQuarter = 4;
              financialYear = year - 1;
            } else if (quarterNum === 2) {
              // Apr-Jun -> Q1
              financialQuarter = 1;
              financialYear = year;
            } else if (quarterNum === 3) {
              // Jul-Sep -> Q2
              financialQuarter = 2;
              financialYear = year;
            } else if (quarterNum === 4) {
              // Oct-Dec -> Q3
              financialQuarter = 3;
              financialYear = year;
            }
            
            periodKey = `Q${financialQuarter} ${financialYear}`;
            console.log(`🔴 Mapping Calendar Quarter ${particulars} -> Financial Quarter ${periodKey}`);
          }
        }
        // ✅ If it's a half-year (contains H), map Calendar Year to Financial Year
        else if (particulars.includes('H')) {
          const match = particulars.match(/(H[1-2])\s*(\d{4})/);
          if (match) {
            let halfNum = parseInt(match[1].replace('H', ''));
            const year = parseInt(match[2]);
            
            let financialHalf;
            let financialYear;
            
            if (halfNum === 1) {
              // Jan-Jun -> H2 of previous financial year
              financialHalf = 2;
              financialYear = year - 1;
            } else if (halfNum === 2) {
              // Jul-Dec -> H1 of current financial year
              financialHalf = 1;
              financialYear = year;
            }
            
            periodKey = `H${financialHalf} ${financialYear}`;
            console.log(`🔴 Mapping Calendar Half-Year ${particulars} -> Financial Half-Year ${periodKey}`);
          }
        }
        // ✅ If it's a month name, keep it as is
        else {
          const monthNames = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 
                             'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'];
          const upperParticulars = particulars.toUpperCase();
          const isMonth = monthNames.some(month => upperParticulars.includes(month));
          if (isMonth) {
            periodKey = upperParticulars;
          }
        }
        
        console.log(`🔴 Mapping: "${particulars}" -> "${periodKey}"`);
        
        // ✅ Store the data with the mapped key
        const inwardQty = Math.abs(Number(item.inwardQty || item.inward_qty || item.InwardQty || 0));
        const outwardQty = Math.abs(Number(item.outwardQty || item.outward_qty || item.OutwardQty || 0));
        const closingBalance = Math.abs(Number(item.closingQty || item.closing_qty || item.ClosingQty || 0));
        
        periodDataMap.set(periodKey, {
          particulars: periodKey,
          inwardQty: inwardQty,
          outwardQty: outwardQty,
          closingBalance: closingBalance,
          startDate: item.startDate || item.start_date || item.StartDate,
          endDate: item.endDate || item.end_date || item.EndDate,
          ledgerAccountId: item.productId || item.product_id || item.ProductId || finalProductId || 0,
          rowId: item.rowId || item.row_id || item.RowId || 0,
          isZeroPeriod: false
        });
      });

      // ✅ Determine the correct end date based on selected financial year
      const fromDateObj = new Date(selectedDateRange[0].startDate);
      let endDateObj = new Date(selectedDateRange[0].endDate);

      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth() + 1;

      // ✅ Get the financial year start year from the selected date
      const financialYearStart = fromDateObj.getFullYear();

      // ✅ Check if selected financial year is the CURRENT financial year
      const isCurrentFinancialYear = 
          (financialYearStart === currentYear) || 
          (financialYearStart === currentYear - 1 && currentMonth < 4);

      if (isCurrentFinancialYear) {
        // ✅ Show only up to current month for current financial year
        const tempEndDate = new Date(currentDate);
        tempEndDate.setMonth(tempEndDate.getMonth() + 1);
        tempEndDate.setDate(0);
        if (tempEndDate < endDateObj) {
          endDateObj = tempEndDate;
          console.log("📊 Current financial year - limiting to current month:", endDateObj);
        }
      } else {
        // ✅ Past or future financial year - show FULL YEAR
        console.log("📊 Past/Future financial year - showing full year");
      }

      console.log("📊 From Date:", fromDateObj);
      console.log("📊 End Date:", endDateObj);

      // ✅ Generate periods from start date to end date
      let allPeriods = [];
if (typeToUse === 'Detail') {
  allPeriods = getMonthsBetweenDates(fromDateObj, endDateObj, true);
} else {
  allPeriods = getPeriods(typeToUse, fromDateObj, endDateObj);
}
      console.log("📊 All periods to display:", allPeriods.length);
      console.log("📊 Periods:", allPeriods.map(p => p.particulars));

      // ✅ Build final data with ALL periods
      let mappedData = [];

      if (openingStockData) {
        mappedData.push(openingStockData);
      }
      
      allPeriods.forEach((period) => {
        const data = periodDataMap.get(period.particulars);
        
        console.log(`🔴 Looking for: ${period.particulars}, Found: ${!!data}`);
        
        if (data) {
          mappedData.push({
            particulars: data.particulars,
            inwardQty: data.inwardQty,
            outwardQty: data.outwardQty,
            closingBalance: data.closingBalance,
            startDate: data.startDate || period.startDate,
            endDate: data.endDate || period.endDate,
            ledgerAccountId: data.ledgerAccountId || finalProductId,
            rowId: data.rowId || 0,
            isZeroPeriod: false
          });
        } else {
          // ✅ Zero balance period
          mappedData.push({
            particulars: period.particulars,
            inwardQty: 0,
            outwardQty: 0,
            closingBalance: 0,
            startDate: period.startDate,
            endDate: period.endDate,
            ledgerAccountId: finalProductId,
            rowId: 0,
            isZeroPeriod: true
          });
        }
      });

      console.log("🔴 Final mapped data with all periods:", mappedData.length);
      console.log("🔴 Final Data:", mappedData);

      setResultData(mappedData);

      let totalInward = mappedData.reduce((sum: number, x: any) => sum + Math.abs(Number(x.inwardQty || 0)), 0);
      let totalOutward = mappedData.reduce((sum: number, x: any) => sum + Math.abs(Number(x.outwardQty || 0)), 0);
      let closing = mappedData.length > 0 ? Math.abs(Number(mappedData[mappedData.length - 1].closingBalance || 0)) : 0;

      const displayName = productName || "Stock Summary";

      setResultTotalData({
        inwardTotal: totalInward,
        outwardTotal: totalOutward,
        closingBalanceTotal: closing,
        accountNature: "DR",
        accountName: displayName,
      });

      console.log("✅ Data set successfully. Rows:", mappedData.length);
      
    } catch (e) {
      console.log("ERROR", e);
    }

    setLoading(false);
  }

  useEffect(() => {
    const finalProductId = decledgerAccountIds || 0;
    
    if (!finalProductId || finalProductId === 0 || isNaN(finalProductId)) {
      console.warn('No valid productId, redirecting to product list');
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: 'Please select a product first',
        alertType: AlertType.Warning,
      });
      navigate('/product-list');
      return;
    }
    
    console.log('Valid productId found, fetching data with summaryType:', summaryType);
    GetStockSummaryLedger();
  }, [location.search, summaryType, selectedDateRange]);

  function searchValue(val: any) {
    if (val === "") {
      setValue("");
    }
    setPage_Index(1);
    setParam({ ...param, searchValue: val.toString(), pageIndex: 1 });
  }

  const descriptionElementRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  function handleDateRange(selected: any) {
    setPageindexUpdate(1);
    setDateRange(selected);
  }

  function safeParseDate(dateStr: string) {
    let parsed = parse(dateStr, "dd-MM-yyyy HH:mm:ss", new Date());
    if (!isValid(parsed)) {
      parsed = parse(dateStr, "dd-MM-yyyy", new Date());
    }
    if (!isValid(parsed)) {
      parsed = new Date(dateStr);
    }
    return parsed;
  }

  // ✅ Navigate to STOCK LEDGER REPORT with proper date range AND summary type
  async function Ledgermonthlist(
    particulars: any,
    ledgerAccountId: any,
    startDate: any,
    endDate: any,
    productNameParam: any = 'Selected Product'
  ) {
    console.log("🔴 LEDGERMONTHLIST CALLED!");
    console.log("🔴 ledgerAccountId:", ledgerAccountId);
    console.log("🔴 particulars:", particulars);
    console.log("🔴 startDate:", startDate);
    console.log("🔴 endDate:", endDate);
    console.log("🔴 Current Summary Type:", summaryType);
    
    try {
      const encryptedProductId = edService.encrypt(ledgerAccountId);
      const encryptedDetailId = edService.encrypt(0);
      
      let formattedStartDate = '';
      let formattedEndDate = '';
      
      if (startDate && endDate) {
        formattedStartDate = format(new Date(startDate), "yyyy-MM-dd");
        formattedEndDate = format(new Date(endDate), "yyyy-MM-dd");
      } else {
        formattedStartDate = format(selectedDateRange[0].startDate, "yyyy-MM-dd");
        formattedEndDate = format(selectedDateRange[0].endDate, "yyyy-MM-dd");
      }
      
      console.log("🔴 Formatted Start Date:", formattedStartDate);
      console.log("🔴 Formatted End Date:", formattedEndDate);
      
      navigate(`/stock-ledger-report?q=${encodeURIComponent(encryptedProductId)}&d=${encodeURIComponent(encryptedDetailId)}`, {
        state: {
          productId: ledgerAccountId,
          startDate: formattedStartDate,
          endDate: formattedEndDate,
          particulars: particulars,
          productName: productNameParam,
          fromSummary: true,
          summaryType: summaryType
        }
      });
      
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }

  const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#25258f",
    },
  }));

  async function openCreditReportPopup(type: any, selectedType?: string) {
    setAnchorEl2(null);
    setLoading(true);

    let params = new URLSearchParams();
    var attachmentName = "";
    if (type === "pdf") {
      attachmentName =
        `LedgerSummary-` + userContext.financialYear + ".pdf";
    } else {
      attachmentName =
        `LedgerSummary-` + userContext.financialYear + ".xls";
    }
    params.append("reportName", "LedgerSummary");
    params.append("reportType", type);
    params.append("consumerId", userContext.consumerId.toString());
    params.append("branchId", userContext.branchId.toString());
    params.append("firmId", userContext.firmId.toString());
    params.append("financialYear", userContext.financialYear.toString());
    params.append("ledgerAccountId", decledgerAccountIds.toString());
    params.append("summaryType", selectedType || summaryType || "Monthly");
    params.append("fileName", attachmentName);
    params.append("mode", "EXPORT");
    params.append("isForDownload", "1");
    try {
      let result: any;
      result = await GetLedgerMonthlySummaryReport(params);
      if (result && result.data && result.data.data) {
        var fileContent = result?.data?.data?.fileData;
        var attachmentData = fileContent;
        ExportFilesFunction(attachmentName, type, attachmentData);
        setLoading(false);
      }
    } catch (e: any) {
      console.log("Error");
    }
    setLoading(false);
  }

  const StyledMenu = styled((props: MenuProps) => (
    <Menu
      elevation={0}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      {...props}
    />
  ))(({ theme }) => ({
    "& .MuiPaper-root": {
      borderRadius: 6,
      marginTop: theme.spacing(1),
      minWidth: 50,
      color:
        theme.palette.mode === "light"
          ? "rgb(55, 65, 81)"
          : theme.palette.grey[300],
      boxShadow:
        "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
      "& .MuiMenu-list": {
        padding: "4px 0",
      },
      "& .MuiMenuItem-root": {
        "& .MuiSvgIcon-root": {
          fontSize: 18,
          color: theme.palette.text.secondary,
          marginRight: theme.spacing(1.5),
        },
        "&:active": {
          backgroundColor: alpha(
            theme.palette.primary.main,
            theme.palette.action.selectedOpacity
          ),
        },
      },
    },
  }));

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
      <Backdrop
        sx={{
          color: "#fff",
          backgroundColor: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={isLoading}>
        <SplashComponent />
      </Backdrop>
      <Box
        className="boxContainer"
        sx={{
          "& > :not(style)": {
            width: "100%",
          },
        }}>
        {userContext.consumerId > 0 ? (
          <Grid>
            <Grid item xs={6} md={3}>
              <Grid
                className="title-button-responsive"
                item
                xs={6}
                md={3}
                sx={{
                  display: "flex !important",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}>
                <h4 className="page-title">
                  {"Stock Ledger Summary"}
                </h4>
                <LoadingButton
                  variant="outlined"
                  onClick={handleBack}>
                  <ShortcutButton label="ESC" />
                  Back
                </LoadingButton>
              </Grid>
            </Grid>
            <Grid className="paper top-space">
              <Paper elevation={4} className="paper-container">
                <Grid
                  container
                  spacing={2}
                  className="search-space"
                  justifyContent="space-between">
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <TextField
                      onKeyPress={(e) => {
                        if (e.key === "Enter") {
                          searchValue(value);
                        }
                      }}
                      placeholder="Search..."
                      type="text"
                      variant="outlined"
                      size="small"
                      fullWidth
                      onChange={(e) => setValue(e.target.value)}
                      value={value}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={() => searchValue(value)}>
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                        endAdornment: value && (
                          <IconButton
                            aria-label="clear"
                            onClick={() => searchValue("")}>
                            <ClearIcon />
                          </IconButton>
                        ),
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
                    <Grid
                      sx={{
                        display: "flex",
                        justifyContent: { xs: "stretch", md: "flex-end" },
                        alignItems: { xs: "stretch", md: "flex-start", lg: "center" },
                        gap: "4px",
                        flexWrap: "wrap",
                        "& > div, & > button, & > Box": {
                          width: { xs: "100%", md: "auto" },
                        },
                        marginBottom: "5px",
                      }}>
                      <Select
                          key={selectedSummaryOption?.value || 'monthly'}
                          options={SUMMARY_BY_DATETIME}
                          value={selectedSummaryOption}
                          defaultValue={SUMMARY_BY_DATETIME[0]}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary: "#25258f",
                              primary25: "#ecebef",
                              primary50: "#e1dfea",
                            },
                          })}
                          onChange={handleListBySummaryType}
                          getOptionValue={(option: any) => option.value}
                          getOptionLabel={(option: any) => option.label}
                          styles={{
                            menu: (base: any) => ({
                              ...base,
                              width: 'auto',
                              minWidth: '250px',
                              zIndex: 9999,
                            }),
                            option: (base: any) => ({
                              ...base,
                              whiteSpace: 'nowrap',
                              padding: '8px 16px',
                            }),
                            control: (base: any, state: any) => ({
                              ...base,
                              minHeight: '40px',
                              borderColor: state.isFocused ? '#25258f' : '#ced4da',
                              boxShadow: state.isFocused ? '0 0 0 1px #25258f' : 'none',
                              '&:hover': {
                                borderColor: '#25258f',
                              },
                            }),
                          }}
                        />
                      <Button
                        sx={{ marginTop: matches ? "10px !important" : "" }}
                        className="Export-button-fix"
                        aria-controls={
                          openExportType ? "demo-customized-menu" : undefined
                        }
                        aria-haspopup="true"
                        aria-expanded={openExportType ? "true" : undefined}
                        variant="outlined"
                        disableElevation
                        onClick={handleClickExportType}
                        startIcon={<DownloadIcon />}
                        endIcon={<KeyboardArrowDownSharp />}>
                        Export
                      </Button>
                      <StyledMenu
                        id="demo-customized-menu"
                        MenuListProps={{
                          "aria-labelledby": "demo-customized-button",
                        }}
                        anchorEl={anchorEl2}
                        open={openExportType}
                        onClose={handleCloseExportType}>
                        <MenuItem
                          onClick={() => openCreditReportPopup("pdf")}>
                          PDF
                        </MenuItem>
                        <MenuItem
                          onClick={() => openCreditReportPopup("Excel")}>
                          EXCEL
                        </MenuItem>
                      </StyledMenu>
                    </Grid>
                  </Grid>
                </Grid>

                <TableContainer>
                  <Table
                    aria-labelledby="tableTitle"
                    size={dense ? "small" : "medium"}>
                    <EnhancedTableHead
                      order={order}
                      orderBy={orderBy}
                      rowCount={resultData.length}
                    />
                    <TableBody>
                      {resultData.length > 0 ? (
                        resultData.map((item: any, index: number) => {
                          const isZeroPeriod = item.isZeroPeriod || false;
                          
                          return (
                            <React.Fragment key={index}>
                              <TableRow hover>
                                <TableCell
                                  sx={{
                                    width: "20px !important",
                                  }}>
                                  {matches2 && (
                                    <IconButton
                                      aria-label="expand row"
                                      size="small"
                                      onClick={() => {
                                        if (expandRow.includes(index)) {
                                          setExpandRow(
                                            expandRow.filter(
                                              (A: any) => A !== index
                                            )
                                          );
                                        } else {
                                          setExpandRow([...expandRow, index]);
                                        }
                                      }}>
                                      {expandRow.includes(index) ? (
                                        <KeyboardArrowUpIcon />
                                      ) : (
                                        <KeyboardArrowDownIcon />
                                      )}
                                    </IconButton>
                                  )}
                                </TableCell>

                                <TableCell
                                  sx={{
                                    display: {
                                      xs: "table-cell",
                                      sm: "table-cell",
                                      md: "table-cell",
                                      lg: "table-cell",
                                    },
                                  }}
                                  align="left">
                                  <Button
                                    disableRipple
                                    sx={{ 
                                      justifyContent: "left",
                                      color: isZeroPeriod ? '#999' : 'inherit'
                                    }}
                                    className="manuButton-link"
                                    color="primary"
                                    onClick={() =>
                                      Ledgermonthlist(
                                        item.particulars,
                                        item.ledgerAccountId,
                                        item.startDate,
                                        item.endDate,
                                        productName || 'Selected Product',
                                      )
                                    }>
                                    <BootstrapTooltip title="Ledger Voucher">
                                      <span className="text-link">
                                        {item.particulars}
                                      </span>
                                    </BootstrapTooltip>
                                    <br />
                                  </Button>
                                </TableCell>

                                <TableCell
                                  sx={{
                                    display: {
                                      xs: "table-cell",
                                      sm: "table-cell",
                                      md: "table-cell",
                                      lg: "table-cell",
                                    },
                                    color: isZeroPeriod ? '#999' : 'inherit'
                                  }}
                                  align="right">
                                  {item?.inwardQty != 0 && !isZeroPeriod
                                    ? numberFormat(Math.abs(item?.inwardQty))
                                    : isZeroPeriod ? "0.00" : ""}
                                </TableCell>

                                <TableCell
                                  sx={{
                                    display: {
                                      xs: "table-cell",
                                      sm: "table-cell",
                                      md: "table-cell",
                                      lg: "table-cell",
                                    },
                                    color: isZeroPeriod ? '#999' : 'inherit'
                                  }}
                                  align="right">
                                  {item?.outwardQty != 0 && !isZeroPeriod
                                    ? numberFormat(Math.abs(item?.outwardQty))
                                    : isZeroPeriod ? "0.00" : ""}
                                </TableCell>

                                <TableCell
                                  sx={{
                                    display: {
                                      xs: "table-cell",
                                      sm: "table-cell",
                                      md: "table-cell",
                                      lg: "table-cell",
                                    },
                                    fontWeight: "600",
                                    color: isZeroPeriod ? '#999' : (item.closingBalance < 0 ? "red" : "inherit")
                                  }}
                                  align="right">
                                  {isZeroPeriod ? (
                                    "0.00"
                                  ) : (
                                    numberFormatWithCrDr(
                                      Math.abs(item.closingBalance || 0),
                                      item.closingBalance < 0 ? "CR" : "DR"
                                    )
                                  )}
                                </TableCell>
                              </TableRow>

                              {matches2 && expandRow.includes(index) ? (
                                <TableRow
                                  sx={{
                                    borderBottom:
                                      "1px solid rgba(224, 224, 224, 1) !important",
                                  }}>
                                  <TableCell
                                    className="noPadding"
                                    colSpan={8}
                                    sx={{
                                      borderBottom: "none",
                                      paddingY: "10px !important",
                                      display: "table-cell",
                                    }}>
                                    <Box
                                      sx={{
                                        borderRadius: 2,
                                        backgroundColor: "#f1f6fe",
                                        padding: 2,
                                      }}>
                                      <Collapse
                                        in={expandRow.includes(index)}
                                        timeout="auto"
                                        unmountOnExit
                                        sx={{ width: "100%" }}>
                                        <Box sx={{ width: "100%" }}>
                                          <Box
                                            sx={{
                                              width: "100%",
                                              display: "flex",
                                              justifyContent:
                                                "space-between !important",
                                              fontSize: "12px !important",
                                            }}>
                                            <Box>Inward Qty</Box>
                                            <Box>Outward Qty</Box>
                                          </Box>
                                          <Box
                                            sx={{
                                              width: "100%",
                                              display: "flex",
                                              justifyContent:
                                                "space-between !important",
                                              fontWeight: "600",
                                            }}>
                                            <Box>
                                              ₹
                                              {item?.inwardQty != 0 && !isZeroPeriod
                                                ? numberFormat(Math.abs(item?.inwardQty))
                                                : "0.00"}
                                            </Box>
                                            <Box>
                                              ₹
                                              {item?.outwardQty != 0 && !isZeroPeriod
                                                ? numberFormat(Math.abs(item?.outwardQty))
                                                : "0.00"}
                                            </Box>
                                          </Box>
                                        </Box>
                                      </Collapse>
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              ) : null}
                            </React.Fragment>
                          );
                        })
                      ) : (
                        <TableRow>
                          <TableCell colSpan={17} align="center">
                            No record(s) found
                          </TableCell>
                        </TableRow>
                      )}

                      {resultData.length > 0 && (
                        <TableRow>
                          <TableCell
                            sx={{
                              width: "20px !important",
                              padding: "8px",
                            }}>
                            {matches2 && (
                              <IconButton
                                aria-label="expand row"
                                size="small"
                                onClick={() => {
                                  setArrow(!arrow);
                                }}>
                                {arrow ? (
                                  <KeyboardArrowUpIcon />
                                ) : (
                                  <KeyboardArrowDownIcon />
                                )}
                              </IconButton>
                            )}
                          </TableCell>

                          <TableCell
                            sx={{
                              display: {
                                xs: "table-cell",
                                sm: "table-cell",
                                md: "table-cell",
                                lg: "table-cell",
                              },
                              fontWeight: "500",
                              fontSize: "14px !important",
                              textTransform: "uppercase !important",
                              color: "#5156be !important",
                              padding: "8px",
                            }}
                            align="left">
                            Total
                          </TableCell>

                          <TableCell
                            sx={{
                              display: {
                                xs: "table-cell",
                                sm: "table-cell",
                                md: "table-cell",
                                lg: "table-cell",
                              },
                              fontWeight: "600",
                              fontSize: "14px !important",
                            }}
                            align="right">
                            {resultTotalData?.inwardTotal != 0 ? (
                              <span>
                                {numberFormat(Math.abs(resultTotalData?.inwardTotal))}
                              </span>
                            ) : (
                              "0.00"
                            )}
                          </TableCell>

                          <TableCell
                            sx={{
                              display: {
                                xs: "table-cell",
                                sm: "table-cell",
                                md: "table-cell",
                                lg: "table-cell",
                              },
                              fontWeight: "600",
                              fontSize: "14px !important",
                            }}
                            align="right">
                            {resultTotalData?.outwardTotal != 0 ? (
                              <span>
                                {numberFormat(Math.abs(resultTotalData?.outwardTotal))}
                              </span>
                            ) : (
                              "0.00"
                            )}
                          </TableCell>

                          <TableCell
                            sx={{
                              display: {
                                xs: "table-cell",
                                sm: "table-cell",
                                md: "table-cell",
                                lg: "table-cell",
                              },
                              fontWeight: "600",
                              fontSize: "14px !important",
                            }}
                            className={
                              resultTotalData?.closingBalanceTotal < 0
                                ? "danger"
                                : ""
                            }
                            align="right">
                            <span>
                              {numberFormatWithCrDr(
                                Math.abs(resultTotalData?.closingBalanceTotal || 0),
                                resultTotalData?.closingBalanceTotal < 0 ? "CR" : "DR"
                              )}
                            </span>
                          </TableCell>
                        </TableRow>
                      )}

                      {matches2 && arrow === true && resultData.length > 0 && (
                        <TableRow
                          sx={{
                            borderBottom:
                              "1px solid rgba(224, 224, 224, 1) !important",
                          }}>
                          <TableCell
                            className="noPadding"
                            colSpan={8}
                            sx={{
                              borderBottom: "none",
                              paddingY: "10px !important",
                              display: "table-cell",
                            }}>
                            <Box
                              sx={{
                                borderRadius: 2,
                                backgroundColor: "#f1f6fe",
                                padding: 2,
                              }}>
                              <Collapse
                                in={arrow}
                                timeout="auto"
                                unmountOnExit
                                sx={{ width: "100%" }}>
                                <Box sx={{ width: "100%" }}>
                                  <Box
                                    sx={{
                                      width: "100%",
                                      display: "flex",
                                      justifyContent:
                                        "space-between !important",
                                      fontSize: "12px !important",
                                    }}>
                                    <Box>Inward Qty</Box>
                                    <Box>Outward Qty</Box>
                                  </Box>
                                  <Box
                                    sx={{
                                      width: "100%",
                                      display: "flex",
                                      justifyContent:
                                        "space-between !important",
                                      fontWeight: "600",
                                    }}>
                                    <Box>
                                      ₹
                                      {resultTotalData?.inwardTotal != 0
                                        ? numberFormat(Math.abs(resultTotalData?.inwardTotal))
                                        : "0.00"}
                                    </Box>
                                    <Box>
                                      ₹
                                      {resultTotalData?.outwardTotal != 0
                                        ? numberFormat(Math.abs(resultTotalData?.outwardTotal))
                                        : "0.00"}
                                    </Box>
                                  </Box>
                                </Box>
                              </Collapse>
                            </Box>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </Grid>
          </Grid>
        ) : (
          <MissingConsumer consumerId={userContext.consumerId} />
        )}
      </Box>
    </>
  );
}